/**
 * Lista de acesso antecipado. Só dados de contato: nada sobre saúde aqui
 * (é dado sensível; a avaliação acontece dentro do app, com consentimento).
 * O envio vai para /api/waitlist.php (roda no cPanel), que valida de novo.
 */

export type WaitlistFields = Partial<Record<"name" | "contact" | "consent", string>>;

export type WaitlistState =
  | { status: "idle" }
  | { status: "error"; message: string; fields?: WaitlistFields }
  | { status: "success"; name: string };

export const WAITLIST_ENDPOINT = "/api/waitlist.php";

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function looksLikePhone(value: string) {
  const digits = value.replace(/\D/g, "");
  return digits.length >= 10 && digits.length <= 13;
}

/** Mensagens de erro no idioma da página. */
export type WaitlistErrors = { name: string; contact: string; consent: string };

export function validateWaitlist(
  data: { name: string; contact: string; consent: boolean },
  errors: WaitlistErrors,
): WaitlistFields {
  const fields: WaitlistFields = {};
  if (data.name.trim().length < 2) fields.name = errors.name;
  const contact = data.contact.trim();
  if (!EMAIL.test(contact) && !looksLikePhone(contact)) fields.contact = errors.contact;
  if (!data.consent) fields.consent = errors.consent;
  return fields;
}
